import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { Placeholder, PlaceholdersStack, } from '../../Toolbar/types'

@Component
export default class PlaceholderMixin extends Vue {
  sectionIndex = -1

  btnIndex = -1

  onSelectSection({ sectionIndex, btnIndex }:{sectionIndex:number, btnIndex:number}):void {
    this.sectionIndex = sectionIndex
    this.btnIndex = btnIndex
  }

  placeholdersBySection(placeholders: PlaceholdersStack['placeholders']):Array<Placeholder> {
    return placeholders[this.sectionIndex].sections[this.btnIndex].placeholders
  }
}
